'use client';

import { NBSP } from '~/constants';
import { useDropsControllerGetMyWhitelistedDrops } from '~/lib/api';

interface DropWhitelistBadgeProps {
  dropId: string;
}

export const DropWhitelistBadge = ({ dropId }: DropWhitelistBadgeProps) => {
  const query = useDropsControllerGetMyWhitelistedDrops();

  const isWhitelisted = query.data?.data.dropIds.includes(dropId);

  if (!isWhitelisted) {
    return null;
  }

  return (
    <span
      className="whitespace-nowrap pl-1 inline"
      style={{
        transform: 'translateY(-4px)',
      }}
    >
      {NBSP}
      <svg className="inline" fill="none" height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4241_14132)">
          <path
            d="M9.93246 0.983654C10.2595 0.704955 10.7405 0.704955 11.0675 0.983654L13.3459 2.92524C13.486 3.04467 13.6603 3.11685 13.8438 3.1315L16.8278 3.36962C17.2561 3.4038 17.5962 3.74392 17.6304 4.17224L17.8685 7.15618C17.8832 7.33973 17.9553 7.51397 18.0748 7.65412L20.0163 9.93246C20.295 10.2595 20.295 10.7405 20.0163 11.0675L18.0748 13.3459C17.9553 13.486 17.8832 13.6603 17.8685 13.8438L17.6304 16.8278C17.5962 17.2561 17.2561 17.5962 16.8278 17.6304L13.8438 17.8685C13.6603 17.8832 13.486 17.9553 13.3459 18.0748L11.0675 20.0163C10.7405 20.295 10.2595 20.295 9.93246 20.0163L7.65412 18.0748C7.51397 17.9553 7.33973 17.8832 7.15618 17.8685L4.17224 17.6304C3.74392 17.5962 3.4038 17.2561 3.36962 16.8278L3.1315 13.8438C3.11685 13.6603 3.04467 13.486 2.92524 13.3459L0.983654 11.0675C0.704955 10.7405 0.704955 10.2595 0.983654 9.93246L2.92524 7.65412C3.04467 7.51397 3.11685 7.33973 3.1315 7.15618L3.36962 4.17224C3.4038 3.74392 3.74392 3.4038 4.17224 3.36962L7.15618 3.1315C7.33973 3.11685 7.51397 3.04467 7.65412 2.92524L9.93246 0.983654Z"
            fill="white"
          />
          <path
            d="M11.4312 7.5245C11.5616 7.5245 11.6862 7.5755 11.8052 7.6775C11.9242 7.77383 11.9837 7.907 11.9837 8.077C11.9837 8.128 11.9752 8.18467 11.9582 8.247L10.2837 13.177C10.2497 13.279 10.1874 13.3583 10.0967 13.415C10.0117 13.466 9.92108 13.4943 9.82475 13.5C9.72841 13.5 9.63208 13.4717 9.53575 13.415C9.44508 13.3583 9.37425 13.2762 9.32325 13.1685L8.06525 10.3125L8.14175 10.3635L6.90075 13.1685C6.84975 13.2762 6.77608 13.3583 6.67975 13.415C6.58908 13.4717 6.49558 13.5 6.39925 13.5C6.30858 13.4943 6.21791 13.466 6.12725 13.415C6.03658 13.3583 5.97425 13.279 5.94025 13.177L4.26575 8.247C4.24875 8.18467 4.24025 8.128 4.24025 8.077C4.24025 7.907 4.29975 7.77383 4.41875 7.6775C4.54341 7.5755 4.67091 7.5245 4.80125 7.5245C4.90891 7.5245 5.00808 7.55283 5.09875 7.6095C5.19508 7.66617 5.26025 7.74833 5.29425 7.856L6.64575 11.953L6.45875 11.9445L7.66575 9.046C7.71108 8.944 7.77625 8.86467 7.86125 8.808C7.94625 8.74567 8.04258 8.71733 8.15025 8.723C8.25791 8.71733 8.35425 8.74567 8.43925 8.808C8.52425 8.86467 8.58658 8.944 8.62625 9.046L9.73125 11.817L9.59525 11.902L10.9297 7.856C10.9637 7.74833 11.0289 7.66617 11.1252 7.6095C11.2216 7.55283 11.3236 7.5245 11.4312 7.5245ZM16.0413 12.5055C16.1886 12.5055 16.3105 12.5537 16.4068 12.65C16.5088 12.7407 16.5598 12.8597 16.5598 13.007C16.5598 13.1487 16.5088 13.2677 16.4068 13.364C16.3105 13.4547 16.1886 13.5 16.0413 13.5H13.2788C13.1315 13.5 13.0068 13.4518 12.9048 13.3555C12.8085 13.2535 12.7603 13.1288 12.7603 12.9815V8.0685C12.7603 7.92117 12.8113 7.79933 12.9133 7.703C13.0153 7.601 13.1456 7.55 13.3043 7.55C13.4403 7.55 13.5593 7.601 13.6613 7.703C13.769 7.79933 13.8228 7.92117 13.8228 8.0685V12.65L13.6358 12.5055H16.0413Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_4241_14132">
            <rect fill="white" height="20" transform="translate(0.5 0.5)" width="20" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
